
import {useState, useContext, useEffect} from 'react';
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import CenterContext from "context/CenterContext";
import ErrorMessage from 'components/ErrorMessage';

const CENTER_VALUES = {
codigoCentro: '',
nombre: '',
horarioAtencion: '',
almacen: '',
recogerEnPunto: false,
ubicacion: {
    codLogistica: '',
    direccion: '',
    latitud: '',
    longitud: ''
},
esCentro: false
 }

 const FORM_WAREHOUSE = {
  _id: '',
  codigo: '',
  nombre: ''
 }

 const FORM_DEPARTAMENT = {
  _id: '',
  codLogistica: '',
  departamento: '',
  ciudad: '',
  estado: false
 }
function Form({createCenter, updateCenter, allWarehouses, allDepartaments, setIsSearched}){
 const {center: selectedCenter, setCenter: setSelectedCenter, message, setMessage} = useContext(CenterContext);

 const [form, setForm] = useState(CENTER_VALUES);
 const [formWarehouse, setFormWarehouse] = useState(FORM_WAREHOUSE);

 const [formDepartament, setFormDepartament] = useState(FORM_DEPARTAMENT);

 const {codigoCentro, nombre, horarioAtencion, almacen, recogerEnPunto, ubicacion, esCentro} = form;
 const {codLogistica, direccion, latitud, longitud} =  ubicacion;
 

 let myAbi = HelpAbility();
 const handleChange = (e) => {
  if(e.target.name === "almacen"){
   const selectedWarehouse = allWarehouses.find(ware => ware._id.toString() === e.target.value)
   if (!selectedWarehouse){
    setFormWarehouse(FORM_WAREHOUSE)
   }else{
    setFormWarehouse({...selectedWarehouse})
   }
   setForm({...form, [e.target.name]: e.target.value});
  }else if(e.target.name === "codLogistica"){
   const selectedDepartament = allDepartaments.find(depart => depart._id.toString() === e.target.value);
   if(!selectedDepartament){
    setFormDepartament(FORM_DEPARTAMENT)
   }else{
    setFormDepartament({...selectedDepartament})
   }
   setForm({...form, "ubicacion": {...form.ubicacion, [e.target.name]: e.target.value }})
  }else if(e.target.name === "direccion" || e.target.name === "latitud" || e.target.name === "longitud" ){
   setForm({...form, "ubicacion": {...form.ubicacion, [e.target.name]: e.target.value }})
  }else{
   setForm({...form, [e.target.name]: e.target.value});
  }
 }

 const handleChangeBool = (e) => {
     setForm({...form, [e.target.name]: e.target.value === 'true'});
 }

 const handleSubmit = async (e) => {
    e.preventDefault();
    let status = Object.keys(selectedCenter).length ? await updateCenter({center: form, id: selectedCenter._id }) : await createCenter({center: form})
    if(!status) {
        setIsSearched({
            search: '',
            option: '',
            state: false
        })
        setForm(CENTER_VALUES) 
        setSelectedCenter({});
        setFormWarehouse(FORM_WAREHOUSE);
        setFormDepartament(FORM_DEPARTAMENT);
        setMessage({message: '', status: 200})
    }
 }
 
 const handleReset = () => {
    setForm(CENTER_VALUES)
    setSelectedCenter({});
    setMessage({message: '', status: 200})
 }
 

 const isVisibleForm = Object.keys(selectedCenter).length ? myAbi.has(C.A.CENTER.UPDATE) : myAbi.has(C.A.CENTER.CREATE);

 useEffect(() => {
    if (!Object.keys(selectedCenter).length) return null;
    setForm(selectedCenter)
    // eslint-disable-next-line
 }, [selectedCenter])

 useEffect(() => {
    if(!form.almacen && !form.ubicacion.codLogistica) return null; 
    const selectedWarehouse = allWarehouses.find(ware => ware._id.toString() === almacen )
    setFormWarehouse({...selectedWarehouse})

    const selectedDepartament = allDepartaments.find(depart => depart._id.toString() === codLogistica);
    setFormDepartament({...selectedDepartament})
    // eslint-disable-next-line
 }, [form])
 
 return (
  <>
  {isVisibleForm 
  &&
  
   <div className="mt-4">
    <div className="row mb-2">
        <h6>{Object.keys(selectedCenter).length ? 'Editar' : 'Agregar'} Centro/Agente</h6>
    </div>
    {message.status !== 200 && message.message && <ErrorMessage message={message.message}></ErrorMessage>}
    <div className="rounded-3 p-3"
                    style={{border: '1px solid black', paddingTop: '15px'}}>
     <div className="d-flex justify-content-center">
      <div className="col-3 themed-grid-col" style={{paddingRight: '10px'}}>
        <div className="mb-3">
            <label htmlFor="codigoCentro" className="form-label">Código Centro</label>
            <input type="text" className="form-control" id="codigoCentro"
                    name="codigoCentro" autoComplete="off" value={codigoCentro} onChange={handleChange} placeholder="Ej. C2300" />
        </div>
        <div className="mb-3">
            <label htmlFor="nombre" className="form-label">Nombre</label>
            <input type="text" className="form-control" id="nombre" name="nombre" autoComplete="off"
                    value={nombre} onChange={handleChange} placeholder="Ej. AquI Llamas"/>
        </div>
        <div className="mb-3">
            <label htmlFor="horarioAtencion" className="form-label">Horario de Atención</label>
            <input type="text" className="form-control" id="horarioAtencion" name="horarioAtencion" autoComplete="off"
                    value={horarioAtencion} onChange={handleChange} placeholder="Ej. 8:00 AM A 5:00 PM"/>
        </div>
        <div className="mb-3">
            <label htmlFor="direccion" className="form-label">Dirección</label>
            <input type="text" className="form-control" id="direccion" name="direccion" autoComplete="off"
                    value={direccion} onChange={handleChange} placeholder="Ej. AV(CR) 68 Nro 17 - 90 PISO 3"/>
        </div>

     </div>

    <div className="col-3 themed-grid-col" style={{paddingLeft: '10px'}}>
        <div className="mb-3">
           <label htmlFor="codLogistica" className="form-label">Código Logístico</label>
           <select onChange={handleChange} className="form-select" aria-label="Default select example" name="codLogistica" value={codLogistica}>
                <option value="">Seleccione</option>
                {allDepartaments.map(departament => <option key={departament._id} value={departament._id}>{departament.codLogistica }</option> )}                
            </select>
        </div>
        <div className="mb-3">
            <label htmlFor="nameDepartament" className="form-label">Departamento</label>
            <input type="text" className="form-control" id="nameDepartament" name="nameDepartament"
                    autoComplete="off" disabled
                    value={formDepartament.departamento}/>
        </div>
        <div className="mb-3">
          <label htmlFor="townDepartament" className="form-label">Municipio</label>
          <input type="text" className="form-control" id="townDepartament" name="townDepartament"
                  autoComplete="off" disabled
                  value={formDepartament.ciudad}/>
        </div>
        <div className="mb-3">
         <label htmlFor="statusDepartamen" className="form-label">Disponibilidad</label>
         <div className="row mb-3">
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="statusDepartament"
                      checked={formDepartament.estado === true} id="isVisible-radio-true"
                      value={true} disabled/>
              <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
              </div>
          </div>
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="statusDepartament"
                      checked={formDepartament.estado === false} id="isVisible-radio-false"
                      value={false} disabled/>
              <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
              </div>
          </div>
         </div>
        </div>
    </div>

    <div className="col-3 themed-grid-col" style={{paddingLeft: '10px'}}>
        <div className="mb-3">
           <label htmlFor="almacen" className="form-label">Código Almacén</label>
           <select onChange={handleChange} className="form-select" aria-label="Default select example" name="almacen" value={almacen}>
                <option value="">Seleccione</option>
                {allWarehouses.map(warehouse => <option key={warehouse._id} value={warehouse._id}>{warehouse.codigo}</option> )}                
            </select>
        </div>
        <div className="mb-3">
            <label htmlFor="nameWarehouse" className="form-label">Nombre Almacén</label>
            <input type="text" className="form-control" id="nameWarehouse" name="nameWarehouse"
                    autoComplete="off" disabled
                    value={formWarehouse.nombre}/>
        </div>
        <div className="mb-3">
            <label htmlFor="latitud" className="form-label">Latitud</label>
            <input type="text" className="form-control" id="latitud" name="latitud" autoComplete="off"
                    value={latitud} onChange={handleChange} placeholder="Ej. 4.64005101"/>
        </div>
        <div className="mb-3">
            <label htmlFor="longitud" className="form-label">Longitud</label>
            <input type="text" className="form-control" id="longitud" name="longitud" autoComplete="off"
                    value={longitud} onChange={handleChange} placeholder="Ej. -74.11525289"/>
        </div>
    </div>


    <div className="col-3 themed-grid-col ms-2" style={{paddingLeft: '10px'}}>
       <div className="mb-3">
         <label htmlFor="statusDepartamen" className="form-label">Centro/Agente</label>
         <div className="row mb-3">
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="esCentro"
                      checked={esCentro === true} id="isVisible-radio-true"
                      value={true} onChange={handleChangeBool}/>
              <label className="form-check-label" htmlFor="isVisible-radio-true">Centro</label>
              </div>
          </div>
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="esCentro"
                      checked={esCentro === false} id="isVisible-radio-false"
                      value={false} onChange={handleChangeBool}/>
              <label className="form-check-label" htmlFor="isVisible-radio-false">Agente</label>
              </div>
          </div>
         </div>
       </div>

       <div className="mb-3">
         <label htmlFor="statusDepartamen" className="form-label">Recoger En Punto</label>
         <div className="row mb-3">
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="recogerEnPunto"
                      checked={recogerEnPunto === true} id="isVisible-radio-true"
                      value={true} onChange={handleChangeBool}/>
              <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
              </div>
          </div>
          <div className="col">
              <div className="form-check form-check-inline">
              <input className="form-check-input" type="radio" name="recogerEnPunto"
                      checked={recogerEnPunto === false} id="isVisible-radio-false"
                      value={false} onChange={handleChangeBool}/>
              <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
              </div>
          </div>
         </div>
       </div>

       <button className={'d-block d-block w-100 mb-2 btn btn-' + (true ? 'success' : 'primary')} type="submit"
               onClick={handleSubmit}><i
           className="bi bi-save"/>{Object.keys(selectedCenter).length ? 'Actualizar' : 'Guardar'}</button>
       <button type="reset" className="d-block w-100 btn btn-secondary" onClick={handleReset}><i
           className="bi bi-eraser"/> Limpiar
       </button>
    </div>
      
     </div>
    </div>
   </div>
  }
  </>
 )
}
export default Form
